import type { Database } from "@/lib/supabase/types";

type Plan = Database["public"]["Tables"]["planos"]["Row"];

/**
 * Obtém a descrição padronizada de um plano
 * Prioriza descricao do banco, depois usa fallbacks baseados no nome
 */
export function getPlanDescription(plan: Plan): string {
  // Se houver descricao no banco, usar ela
  if (plan.descricao && plan.descricao.trim()) {
    return plan.descricao;
  }

  // Fallback baseado no nome
  const nomeLower = plan.nome.toLowerCase();
  if (nomeLower.includes("free") || nomeLower.includes("grátis") || nomeLower.includes("gratis")) {
    return "Experimente gratuitamente";
  }
  if (nomeLower.includes("básico") || nomeLower.includes("basico")) {
    return "Ideal para pequenas equipes";
  }
  if (nomeLower.includes("empresa") || nomeLower.includes("enterprise")) {
    return "Para empresas em crescimento";
  }
  if (nomeLower.includes("premium") || nomeLower.includes("pro")) {
    return "Solução enterprise completa";
  }

  // Fallback genérico
  return "Solução enterprise completa";
}

/**
 * Obtém as features padronizadas de um plano
 * Prioriza features_personalizadas do banco, depois gera automaticamente
 */
export function getPlanFeatures(plan: Plan): string[] {
  // Se houver features personalizadas no banco, usar elas
  if (plan.features_personalizadas && Array.isArray(plan.features_personalizadas) && plan.features_personalizadas.length > 0) {
    return plan.features_personalizadas;
  }

  // Caso contrário, gerar features automaticamente
  const features: string[] = [];
  
  if (plan.max_usuarios === -1) {
    features.push("Usuários ilimitados");
  } else if (plan.max_usuarios > 0) {
    features.push(`Até ${plan.max_usuarios} usuário${plan.max_usuarios > 1 ? "s" : ""}`);
  }
  
  if (plan.max_agentes === -1) {
    features.push("Agentes ilimitados");
  } else if (plan.max_agentes > 0) {
    features.push(`Até ${plan.max_agentes} agente${plan.max_agentes > 1 ? "s" : ""}`);
  }
  
  if (plan.limite_mensagens_mes === -1) {
    features.push("Mensagens ilimitadas");
  } else if (plan.limite_mensagens_mes > 0) {
    features.push(`${plan.limite_mensagens_mes.toLocaleString("pt-BR")} mensagens/mês`);
  }
  
  features.push("Traga sua própria API");
  features.push("Segurança completa");
  
  return features;
}

/**
 * Formata o preço de um plano
 */
export function formatPlanPrice(price: number | null | undefined): string {
  if (!price || price === 0) return "Grátis";
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(price);
}

